import { render, staticRenderFns } from "./SupportTable.vue?vue&type=template&id=efe61f94&scoped=true&"
import script from "./SupportTable.vue?vue&type=script&lang=js&"
export * from "./SupportTable.vue?vue&type=script&lang=js&"
import style0 from "./SupportTable.vue?vue&type=style&index=0&id=efe61f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe61f94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VSimpleTable})
